<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Şifrəmi unutdum</h2>

    <div *ngIf="!successMessage">
      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label for="phoneNumber">Telefon nömrəsi</label>
          <input
            type="text"
            id="phoneNumber"
            formControlName="phoneNumber"
            placeholder="+994 (0XX) XXX-XX-XX"
            (input)="onPhoneInput($event)"
            [class.invalid]="forgotForm.get('phoneNumber')?.invalid && forgotForm.get('phoneNumber')?.touched"
          >
          <div class="error-message" *ngIf="forgotForm.get('phoneNumber')?.invalid && forgotForm.get('phoneNumber')?.touched">
            <span *ngIf="forgotForm.get('phoneNumber')?.errors?.['required']">Telefon nömrəsi daxil edilməlidir.</span>
            <span *ngIf="forgotForm.get('phoneNumber')?.errors?.['pattern']">Düzgün operator daxil etməmisiniz.</span>
          </div>
        </div>

        <div class="error-message general-error" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <button type="submit" class="btn-submit" [disabled]="forgotForm.invalid || isLoading">
          {{ isLoading ? 'Göndərilir...' : 'Kod göndər' }}
        </button>
      </form>
    </div>

    <div *ngIf="successMessage" class="success-message">
      <p>{{ successMessage }}</p>
    </div>

    <div class="auth-links" style="margin-top: 20px; text-align: center;">
      <a [routerLink]="['/login']">Giriş ekranına qayıt</a>
    </div>
  </div>
</div>
